import { Box, Button } from '@mui/material';
import React, { useState } from 'react';
import { useGetCreditHoldsQuery } from '../../../app/Slices/SevenDayApiSlice';
import { MRT_ColumnDef } from 'mantine-react-table';
import GenericTable from '../../shared/GenericTable';
import { Add } from '@mui/icons-material';
import { CreditHold } from '../../types/credit-hold';
import CreditHoldModal from './CreditHoldModal';
import NewCreditHoldModal from './NewCreditHoldModal';

export type Status =
    | 'pending'
    | 'accepted'
    | 'declined'
    | 'cancelled'
    | 'completed'
    | undefined;

interface JobListProps {
    status?: Status;
    bookingId?: number;
}

const CreditHoldList = () => {
    const { data: creditHolds, isFetching } = useGetCreditHoldsQuery();

    const [selectedCreditHold, setSelectedCreditHold] = useState<number>(0);
    const [creditHoldOpen, setCreditHoldOpen] = useState(false);
    const [formOpen, setFormOpen] = useState(false);

    const handleView = (creditHold: CreditHold) => {
        setSelectedCreditHold(creditHold.id);
        setCreditHoldOpen(true);
    };

    const handleClose = () => {
        setCreditHoldOpen(false);
    };

    const columns: MRT_ColumnDef<any>[] = [
        {
            accessorKey: 'id',
            header: 'Credit Hold Id',
            Cell: ({ cell }) => {
                return `#${cell.getValue()}`;
            },
        },
        {
            accessorKey: 'guest.name',
            header: 'Guest Company',
        },
        {
            accessorKey: 'placedAt',
            header: 'Placed At',
            Cell: ({ cell }) => {
                return new Date(cell.getValue<string>()).toLocaleDateString(
                    'en-AU',
                );
            },
        },
        {
            accessorKey: 'removedAt',
            header: 'Removed At',
            Cell: ({ cell }) => {
                return cell.getValue()
                    ? new Date(cell.getValue<string>()).toLocaleDateString(
                          'en-AU',
                      )
                    : 'N/A';
            },
        },
    ];

    return (
        <>
            <Box sx={{ width: '100%', paddingTop: '20px' }}>
                <Box
                    sx={{
                        display: 'flex',
                        justifyContent: 'flex-end',
                        pb: 1,
                    }}
                >
                    <Button
                        variant='contained'
                        startIcon={<Add />}
                        sx={{ my: 1 }}
                        onClick={() => setFormOpen(true)}
                    >
                        Create Manual Credit Hold
                    </Button>
                </Box>
                <GenericTable
                    columns={columns}
                    data={creditHolds ?? []}
                    tableName='CreditHold-List'
                    loading={!creditHolds}
                    onRowClick={(row) => handleView(row)}
                    cursor={'pointer'}
                />
                <CreditHoldModal
                    id={selectedCreditHold}
                    open={creditHoldOpen}
                    onClose={handleClose}
                />
            </Box>
            <NewCreditHoldModal
                open={formOpen}
                onClose={() => setFormOpen(false)}
            />
        </>
    );
};

export default CreditHoldList;
